export default "__VITE_ASSET__BWIr9Zn3__"